import { Grid } from "antd-mobile";
import Logo from "components/dot/logo";
import { MoeCounter } from "components/dot/moe-counter";
import { useI18n } from "i18n/useI18n";
import React from "react";

const Footer: React.FC = () => {
  const { t } = useI18n();
  return (
    <>
      <div className=" flex justify-center items-center">
        <MoeCounter />
        {/* <p style={{ color: "#999", fontSize: 12, margin: 10 }}>
          Copyright © <span style={{ whiteSpace: "nowrap" }}>2016-{new Date().getFullYear()}</span>
        </p>
        <div style={{ width: 100, margin: 10 }}>
          <Logo />
        </div>
        <p style={{ color: "#999", fontSize: 12, margin: 10 }}>
          Ireina.com <span style={{ whiteSpace: "nowrap" }}>All Rights</span>
        </p> */}
      </div>
    </>
  );
};

export default Footer;
